import { GEO_SCALE, PIXELS_PER_METER } from '@yard/pages/YardSetup/helpers/yard-view.utils'
import { TenantConfigService } from '@yard/services/tenant-config.service'
import { useEffect, useState } from 'react'
import { GeoAnchor } from '../utils/geo-transform'

const tenantConfigService = new TenantConfigService()

export function useGeoAnchor(): GeoAnchor | null {
  const [geoAnchor, setGeoAnchor] = useState<GeoAnchor | null>(null)

  useEffect(() => {
    tenantConfigService.get().then(config => {
      const { yardMapAnchorLatitude, yardMapAnchorLongitude, yardMapNorthRotationDegrees } = config

      if (
        yardMapAnchorLatitude != null &&
        yardMapAnchorLongitude != null &&
        yardMapNorthRotationDegrees != null
      ) {
        setGeoAnchor({
          latitude: yardMapAnchorLatitude,
          longitude: yardMapAnchorLongitude,
          metersPerPixel: GEO_SCALE / PIXELS_PER_METER,
          northRotationDegrees: yardMapNorthRotationDegrees,
        })
      }
    })
  }, [])

  return geoAnchor
}
